<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 生产管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>班组管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="5">
              <el-form-item label="班组编码" prop="workgroup_code" label-width="100px">
                <el-input v-model="searchform.workgroup_code" style="width:100%" clearable placeholder="请输入班组编码" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="班组名称" prop="workgroup_name" label-width="100px">
                <el-input v-model="searchform.workgroup_name" style="width:100%" clearable placeholder="请输入班组名称" />
              </el-form-item>
            </el-col>
            <el-col :span="8" style="margin-left:10px">
              <el-button type="primary" icon="el-icon-search" @click="search"
                v-permission="['classlist_selete']">搜索</el-button>
              <el-button @click="resetForm('searchform')">重置</el-button>
            </el-col>
          </el-row>
        </el-form>

        <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
          v-permission="['classlist_add']">新建班组</el-button>
        <!-- <el-button
          :loading="downloadLoading"
          type="primary"
          icon="document"
          @click="handleDownload"
        >导出Excel</el-button>-->
      </div>
      <el-divider></el-divider>
      <el-row type="flex" class="row-bg">
        <el-col :span="24">
          <el-table v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData" border style="width:90%"
            @cell-click="danhang">
            <el-table-column prop="workgroup_code" label="班组编号"></el-table-column>
            <el-table-column prop="workgroup_name" label="班组名称"></el-table-column>
            <el-table-column prop="action" label="操作" width="220">
              <el-button-group>
                <el-button type="primary" plain size="mini" @click="update"
                  v-permission="['classlist_update']">修改</el-button>
                <el-button type="danger" plain size="mini" @click="deletedata"
                  v-permission="['classlist_delete']">删除</el-button>
              </el-button-group>
            </el-table-column>
          </el-table>
          <br />
          <!-- 编辑修改出框 -->
          <el-dialog title="编辑" :visible.sync="editVisible" center width="30%">
            <el-form :model="form" ref="form" label-width="80px">
              <el-row>
                <el-form-item label="班组编号" prop="workgroup_code">
                  <el-input v-model="form.workgroup_code" style="width:80%" placeholder="请输入班组编号" />
                </el-form-item>
                <el-form-item label="班组名称" prop="workgroup_name">
                  <el-input v-model="form.workgroup_name" style="width:80%" placeholder="请输入班组名称" />
                </el-form-item>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="editVisible = false">取 消</el-button>
              <el-button type="primary" @click="submit">确 定</el-button>
            </span>
          </el-dialog>
          <!-- 新增弹出框 -->
          <el-dialog title="添加" :visible.sync="dialogVisible" @close="resetForm('formadd')" width="28%" :modal="true"
            center>
            <el-form :model="formadd" :rules="rules" ref="formadd" label-width="80px" style="margin-left:15%">
              <el-row>
                <el-form-item label="班组编号" prop="workgroup_code">
                  <el-input v-model="formadd.workgroup_code" style="width:80%" placeholder="请输入班组编号" />
                </el-form-item>
                <el-form-item label="班组名称" prop="workgroup_name">
                  <el-input v-model="formadd.workgroup_name" style="width:80%" placeholder="请输入班组名称" />
                </el-form-item>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button @click="resetForm('formadd')">重置</el-button>
              <el-button type="primary" @click="submitadd('formadd')">确 定</el-button>
            </span>
          </el-dialog>
          <!-- <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination> -->
          <el-divider></el-divider>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  workgrouplist,
  workgroupadd,
  workgroupdelete,
  workgroupupdate
} from "@/api/plant";
//引入导出组件模块
import FilenameOption from "@/views/excel/components/FilenameOption";
import AutoWidthOption from "@/views/excel/components/FilenameOption";
import BookTypeOption from "@/views/excel/components/FilenameOption";
import { construct, destruct } from "@aximario/json-tree";
export default {
  name: "ExportExcel",
  components: { FilenameOption, AutoWidthOption, BookTypeOption },
  mounted() {
    //请求部门列表数据并且便利到表格
    this.Tabledata();
  },
  data() {
    return {
      // 下拉数据
      //基础数据
      dialogVisible: false,
      editVisible: false,
      tableData: [],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      searchform: {
        workgroup_uuid: null,
        workgroup_code: null,
        workgroup_name: null,
        enterprise_code: null
      },
      //导出表格变量
      listLoading: true,
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //修改表单数据
      form: {
        workgroup_uuid: "",
        workgroup_code: "",
        workgroup_name: "",
      },
      //新增弹窗变量begin
      //表单数据
      formadd: {
        workgroup_uuid: "",
        workgroup_code: "",
        workgroup_name: "",
      },
      //基础表单验证
      rules: {
        workgroup_name: [
          { required: true, message: "请输入班组名称", trigger: "blur" },
        ],
        workgroup_code: [
          { required: true, message: "请输入班组编号", trigger: "blur" }
          , { validator: this.$validateaccount, trigger: "blur" }
        ],
        factory_type: [
          { required: true, message: "请选择工厂类别", trigger: "change" }
        ],
        // factory_address: [
        //   { required: true, message: "请输入地址", trigger: "blur" }
        // ],
      }
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      workgrouplist({
        workgroup_uuid: null,
        workgroup_code: null,
        workgroup_name: null,
        enterprise_code: null
      }).then(response => {
        this.tableData = response.data;
        this.total_count = response.data.total_count;
        this.currentPage = response.data.page_index;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    //新增保存提示
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          this.dialogVisible = false;
          workgroupadd({
            workgroup_code: this.formadd.workgroup_code,
            workgroup_name: this.formadd.workgroup_name,
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "添加成功!"
              });
              this.resetForm(formName);
              this.Tabledata();
              console.log(this.formadd.account_status);
            } else {
              this.$message({
                type: "warning",
                message: "添加失败!请检查字段"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //搜索事件
    search() {
      workgrouplist(this.searchform).then(response => {
        this.tableData = response.data;
        this.total_count = response.data?.total_count ?? 0;
        this.currentPage = response.data?.page_index ?? 0;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(pageIndex) {
      this.currentPage = pageIndex;
      this.Tabledata({ pageIndex });
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.Tabledata({ pageSize });
    },
    //表格单行点击
    danhang(row) {
      this.form.workgroup_uuid = row.workgroup_uuid;
      this.form.workgroup_code = row.workgroup_code;
      this.form.workgroup_name = row.workgroup_name;
      console.log(this.form.factory_type);
    },
    // 修改弹窗保存       请求接口！！
    submit() {
      this.editVisible = false;
      workgroupupdate({
        workgroup_uuid: this.form.workgroup_uuid,
        workgroup_code: this.form.workgroup_code,
        workgroup_name: this.form.workgroup_name,
      }).then(response => {
        if (response.status_code == 200) {
          this.$message({
            type: "success",
            message: "修改成功!"
          });
          this.currentchange(this.currentPage);
        } else {
          this.$message({
            type: "woring",
            message: "修改失败!请检查字段"
          });
        }
      });
    },
    // 修改按钮弹窗
    update() {
      setTimeout(() => {
        (this.requestnum = "1"), (this.editVisible = true); //弹窗false关闭 true开启
      }, 200);
    },
    //删除按钮事件
    deletedata() {
      this.$confirm("此操作将永久删除该班组信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          workgroupdelete({
            workgroup_uuid: this.form.workgroup_uuid
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.Tabledata();
            } else {
              this.$message({
                type: "woring",
                message: "删除失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      import("@/vendor/Export2Excel").then(excel => {
        const tHeader = [
          "登录账号",
          "账号名称",
          "角色",
          "账号类型",
          "账号状态"
        ];
        const filterVal = [
          "account_name",
          "employee_name",
          "role_name",
          "permissions_name",
          "account_status_name"
        ];
        const list = this.tableData;
        console.log(this.tableData);
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        });
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/workshoplist"
      });
    }
  }
};
</script>
<style scoped></style>
